// Simple RAG Service for DendriteAI - Frontend calls backend
import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

function callableErrorMessage(error, functionName) {
  const code = error?.code || '';
  const msg = String(error?.message || '');
  if (
    code === 'functions/internal' ||
    code === 'internal' ||
    msg.includes('CORS') ||
    msg.includes('Failed to fetch')
  ) {
    return (
      `Could not reach ${functionName}. This is usually a Cloud Run permissions issue, not RAG logic. ` +
      'Redeploy: firebase deploy --only functions:generateResponse,functions:embedDocument — ' +
      'then run: bash scripts/fix-callable-invoker.sh'
    );
  }
  if (code === 'functions/unauthenticated' || code === 'unauthenticated') {
    return 'Please sign in again to use AI features.';
  }
  return msg || 'Unknown error';
}

class RAGService {
  constructor() {
    this.embedDocument = this.embedDocument.bind(this);
    this.generateResponse = this.generateResponse.bind(this);
  }

  async embedDocument(document, userId, projectId = null) {
    try {
      const embedDocumentFunction = httpsCallable(functions, 'embedDocument');
      const result = await embedDocumentFunction({
        document,
        userId,
        projectId
      });

      console.log(`✅ Document embedded via backend: ${document.id}`);
      return { success: true, chunksCount: result.data.chunksCount || 0 };
    } catch (error) {
      const friendly = callableErrorMessage(error, 'embedDocument');
      console.error('❌ Error embedding document via backend:', error);
      return { success: false, error: friendly };
    }
  }

  async generateResponse(
    query,
    userId,
    projectId = null,
    workspaceId = null,
    conversationHistory = [],
    options = {}
  ) {
    try {
      const generateResponseFunction = httpsCallable(functions, 'generateResponse');
      const result = await generateResponseFunction({
        query,
        userId,
        projectId,
        workspaceId,
        conversationHistory,
        interviewMode: Boolean(options.interviewMode),
        templateId: options.templateId || null
      });

      return {
        success: true,
        response: result.data.response,
        sources: result.data.sources || [],
        confidence: result.data.confidence || 'medium',
        interviewComplete: Boolean(result.data.interviewComplete)
      };
    } catch (error) {
      const friendly = callableErrorMessage(error, 'generateResponse');
      console.error('❌ Error generating response via backend:', error);
      return {
        success: false,
        response: friendly,
        error: friendly
      };
    }
  }
}

export const ragService = new RAGService();
export default ragService;
